import * as z from "zod";

export const getSignupFormDisclosureSupportEmail = {
  name: "getSignupFormDisclosureSupportEmail" as const,
  input: z.object({}),
  output: z.object({ supportEmail: z.string().nullable() }),
};
